module.exports = __webpack_public_path__ + "img/slide15.2dbe4291.png";